export default __webpack_public_path__ + "static/lightLogo-caf1beca2eb38a5e67a198f2f34162b0.svg";